const configuredDashboardUrl = process.env.REACT_APP_DASHBOARD_URL || '';

const trimTrailingSlash = (value) => value.replace(/\/+$/, '');

export const getDashboardBaseUrl = () => {
  const configured = trimTrailingSlash(configuredDashboardUrl.trim());
  if (configured) return configured;

  if (typeof window === 'undefined') return '';
  const path = window.location.pathname === '/' ? '' : window.location.pathname;
  return trimTrailingSlash(`${window.location.origin}${path}`);
};

export const buildDashboardInviteUrl = (token) => {
  const base = getDashboardBaseUrl();
  if (!token) return base;
  return `${base}?invite=${encodeURIComponent(token)}`;
};

export const isUsingLocalDashboardBase = () => {
  if (configuredDashboardUrl.trim()) return false;
  if (typeof window === 'undefined') return false;
  return ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
};
